import {
	ButtonPrimary,
	Select,
	TextField,
	skinVars,
	useScreenSize,
	Grid,
	GridItem,
	ButtonLayout,
	Box,
	Text2,
} from "@telefonica/mistica";
import React from "react";
import { formatAmount, parseMoneyToDecimal } from "../../utils/formatters";
import { DataInfo } from "../DataInfo";
import { MIN_VALUE_ANTICIPATION, months } from "../../constants";
import { strings } from "../../localization";
import { observer } from "mobx-react-lite";
import { useAnalytics } from "../../hooks/useAnalytics";

interface IProps {
	errorFGTSValue?: string;
	fgtsBalance: string;
	birthMonth: string;
	isLoading?: boolean;
	onChangeFGTSBalance(fgts: string): void;
	onSelectBirthMonth(birth: string): void;
	onSubmit(): void;
}

export const PreSimulationForm: React.FC<IProps> = observer((props) => {
	const {
		fgtsBalance,
		birthMonth,
		onChangeFGTSBalance,
		onSelectBirthMonth,
		errorFGTSValue = strings.components.coldSimulator.fgtsErrorText,
		isLoading = false,
		onSubmit,
	} = props;
	const labels = strings.components.coldSimulator;
	const fgtsError = fgtsBalance !== "" && parseMoneyToDecimal(fgtsBalance) < MIN_VALUE_ANTICIPATION;

	const disableButton = fgtsError || birthMonth === "" || fgtsBalance === "";

	const { isDesktopOrBigger } = useScreenSize();
	const { addAnalyticEvent } = useAnalytics();

	const handleAnalyticInteraction = (description: string): void => {
		addAnalyticEvent(
			{
				component: "body",
				action: "click:button",
				description,
				step: "home:simulador-antecipacao",
				value: fgtsBalance || "",
			},
			{ applySanitize: true },
		);
	};

	return (
		<Box className="pre-simulation-form-box">
			<DataInfo title={labels.title} stackSpace={24}>
				<Grid columns={isDesktopOrBigger ? 2 : 1} rows={isDesktopOrBigger ? 1 : 3} gap={isDesktopOrBigger ? [16, 24] : 16}>
					<GridItem span={1}>
						<TextField
							label={labels.fgtsLabel}
							placeholder={labels.fgtsLabel}
							name="fgtsBalance"
							error={fgtsError}
							value={fgtsBalance}
							onChange={(e) => onChangeFGTSBalance(formatAmount(parseMoneyToDecimal(e.target.value)))}
							onPress={() => handleAnalyticInteraction(labels.fgtsLabel)}
							helperText={fgtsError ? errorFGTSValue : labels.fgtsHelpText}
							fullWidth
							data-cs-mask
						/>
					</GridItem>

					<GridItem span={1}>
						<Select
							label={labels.birthLabel}
							name="birthMonth"
							value={birthMonth}
							options={months}
							onChangeValue={onSelectBirthMonth}
							optional={false}
							fullWidth
						/>
					</GridItem>

					<GridItem span={1}>
						<ButtonLayout align="left">
							<ButtonPrimary
								onPress={() => {
									handleAnalyticInteraction(labels.buttonText);
									if (!disableButton) {
										onSubmit();
									}
								}}
								showSpinner={isLoading}
								style={{
									width: "fit-content",
									opacity: disableButton ? "50%" : "100%",
									cursor: disableButton ? "default" : "pointer",
									backgroundColor: disableButton ? "#660099" : "",
									borderRadius: "999px",
								}}
							>
								<Text2 medium color={skinVars.colors.textButtonPrimary}>
									{labels.buttonText}
								</Text2>
							</ButtonPrimary>
						</ButtonLayout>
					</GridItem>
				</Grid>
			</DataInfo>
		</Box>
	);
});
